import React from "react";
import { CheckCircle, XCircle } from "lucide-react";

export default function ResultCard({ result }) {
  if (!result) return null;

  return (
    <div className="result-card">
      <h2>Test Complete</h2>

      <div className="candidate-details">
        <h3>Candidate Information</h3>
        <p><strong>Name:</strong> {result.student_name}</p>
        <p><strong>Email:</strong> {result.email}</p>
        <p><strong>Exam:</strong> {result.exam_name}</p>
      </div>

      <div className="result-stats">
        <div className="result-stat">
          <span>Gross WPM</span>
          <strong>{result.gross_wpm}</strong>
        </div>

        <div className="result-stat">
          <span>Net WPM</span>
          <strong>{result.net_wpm}</strong>
        </div>

        <div className="result-stat">
          <span>Accuracy</span>
          <strong>{result.accuracy}%</strong>
        </div>

        <div className="result-stat">
          <span>Errors</span>
          <strong>{result.errors}</strong>
        </div>
      </div>

      <div className="result-paragraphs">
        <div>
          <h3>Paragraph Given</h3>
          <p>{result.paragraph}</p>
        </div>

        <div>
          <h3>Your Typed Text</h3>
          <p>{result.typed_text}</p>
        </div>
      </div>

      <div className={`result-badge ${result.result === "Pass" ? "pass" : "fail"}`}>
        {result.result === "Pass" ? (
          <>
            <CheckCircle size={22}/>
            PASS
          </>
        ) : (
          <>
            <XCircle size={22}/>
            FAIL
          </>
        )}
      </div>
    </div>
  );
}